import TraderModal from "../features/traders/components/TraderModal";

export default function AdvancedFiltersModal({
  isOpen,
  onClose,
  title = "Filters",
  activeCount = 0,
  onClear,
  clearLabel = "Clear filters",
  children
}) {
  return (
    <TraderModal isOpen={isOpen} onClose={onClose} title={title} width="760px">
      <div style={{ display: "grid", gap: "18px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", flexWrap: "wrap" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", color: "#475569", fontSize: "13px", fontWeight: 600 }}>
            <span>Advanced filters</span>
            {activeCount > 0 ? (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "24px",
                  height: "24px",
                  padding: "0 8px",
                  borderRadius: "999px",
                  background: "#ccfbf1",
                  color: "#115e59",
                  fontSize: "12px",
                  fontWeight: 800
                }}
              >
                {activeCount}
              </span>
            ) : null}
          </div>
          <button
            type="button"
            onClick={onClear}
            disabled={!onClear || activeCount === 0}
            style={{
              height: "40px",
              padding: "0 14px",
              borderRadius: "12px",
              border: "1px solid #cbd5e1",
              background: activeCount === 0 ? "#f8fafc" : "#ffffff",
              color: activeCount === 0 ? "#94a3b8" : "#0f172a",
              cursor: activeCount === 0 ? "not-allowed" : "pointer",
              fontSize: "13px",
              fontWeight: 700
            }}
          >
            {clearLabel}
          </button>
        </div>
        <div style={{ display: "grid", gap: "16px" }}>
          {children}
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              height: "42px",
              padding: "0 18px",
              borderRadius: "12px",
              border: "1px solid #0f766e",
              background: "#0f766e",
              color: "#ffffff",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: 700
            }}
          >
            Done
          </button>
        </div>
      </div>
    </TraderModal>
  );
}